// Costruisce gli URL verso Shopify senza svuotare il carrello esistente:
// /cart/update imposta la quantità assoluta (1) delle varianti della routine, aggiungendo quelle mancanti,
// e azzera le varianti inviate in precedenza che la cliente ha poi tolto dalla routine.
// Modalità "checkout": permalink diretto al checkout.
export const checkoutPermalink = (items, domain, sessionId, utm) => {
  const qs = new URLSearchParams({ ...utm, "attributes[_fs_session]": sessionId }).toString();
  return `https://${domain}/cart/${items.map((p) => `${p.shopify_variant_id}:1`).join(",")}?${qs}`;
};

export const cartUpdateUrl = (items, domain, sessionId, utm, previous = []) => {
  const params = new URLSearchParams({ ...utm, "attributes[_fs_session]": sessionId });
  const current = new Set(items.map((p) => String(p.shopify_variant_id)));
  items.forEach((p) => params.set(`updates[${p.shopify_variant_id}]`, "1"));
  previous.map(String).filter((v) => !current.has(v)).forEach((v) => params.set(`updates[${v}]`, "0"));
  params.set("return_to", "/cart");
  return `https://${domain}/cart/update?${params.toString()}`;
};

export const buildCartUrl = ({ items, domain, sessionId, utm, mode, previous = [] }) => {
  if (!items.length || !domain) return "";
  if (mode === "checkout") return checkoutPermalink(items, domain, sessionId, utm);
  return cartUpdateUrl(items, domain, sessionId, utm, previous);
};
